import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from "@app/shared/components";
import { RevisionInfo } from "@components/revision-info/models/revision-info.model";

@Component({
    selector: 'app-revision-info-modal',
    templateUrl: './revision-info-modal.component.html',
    styleUrls: ['./revision-info-modal.component.scss']
})
export class RevisionInfoModalComponent implements OnInit {
    @ViewChild(ModalComponent, {static: false}) modal: ModalComponent;

    @Input() title = '';

    revisionInfo: RevisionInfo[] = [];
    constructor() { }

    ngOnInit() {
    }

    open(revisionInfo: RevisionInfo[]) {
        if (revisionInfo) {
            this.revisionInfo = revisionInfo;
        }
        this.modal.open();
    }

    onCancel() {
        this.revisionInfo = [];
        this.modal.close();
    }
}
